import api from "./api";

const EventService = {
    getAll: async () => {
        try {
            const response = await api.get("/api/events", { params: { size: 9999 } });
            const data = response.data;
            return Array.isArray(data) ? data : (data?.content || data?.items || data?.data || []);
        } catch (error) {
            console.error("Error fetching all events:", error);
            throw error;
        }
    },

    getBySlug: async (slug) => {
        try {
            return await api.get(`/api/events/${slug}`);
        } catch (error) {
            console.error(`Error fetching event by slug: ${slug}`, error);
            throw error;
        }
    }
};

export default EventService;



